import React from 'react';
import { Printer, Download } from 'lucide-react';
import { generateInvoicePDF, downloadPDF } from '../utils/exportUtils';
import '../styles/Modal.css';

function InvoiceViewModal({ invoice, customer, onClose, onPrint, onDownloadPDF }) {
  if (!invoice || !customer) return null;

  return (
    <div className="modal-overlay">
      <div className="modal invoice-view-modal">
        <div className="modal-header">
          <h2>Invoice Details - {invoice.invoiceNumber}</h2>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>

        <div className="invoice-view-content">
          {/* Header */}
          <div className="invoice-view-header">
            <div className="invoice-title">
              <h3>SSP BILLING SYSTEM</h3>
              <p className="invoice-type">TAX INVOICE</p>
            </div>
            <div className="invoice-details">
              <p><strong>Invoice No:</strong> {invoice.invoiceNumber}</p>
              <p><strong>Date:</strong> {new Date(invoice.invoiceDate).toLocaleDateString('en-IN')}</p>
              <p><strong>Payment Mode:</strong> {invoice.paymentMode}</p>
            </div>
          </div>

          {/* Customer Details */}
          <div className="invoice-customer-box">
            <h4>Bill To:</h4>
            <p><strong>{customer.fullName}</strong></p>
            {customer.companyName && <p>{customer.companyName}</p>}
            <p>{customer.street}, {customer.area}</p>
            <p>{customer.city}, {customer.state} {customer.pincode}</p>
            <p>Phone: {customer.phoneNumber}</p>
            {customer.gstinNumber && <p>GSTIN: {customer.gstinNumber}</p>}
          </div>

          {/* Items Table */}
          <div className="invoice-items-section">
            <table className="invoice-view-table">
              <thead>
                <tr>
                  <th>SL</th>
                  <th>Product</th>
                  <th>HSN</th>
                  <th>State</th>
                  <th>Qty</th>
                  <th>Rate</th>
                  <th>MRP</th>
                  <th>Disc%</th>
                  <th>Taxable</th>
                  <th>Tax%</th>
                  <th>SGST</th>
                  <th>CGST</th>
                  <th>IGST</th>
                  <th>Total</th>
                </tr>
              </thead>
              <tbody>
                {invoice.items && invoice.items.map((item, idx) => {
                  // Taxable = Rate * Quantity
                  const quantity = Number(item.quantity || 0);
                  const rate = Number(item.rate || 0);
                  const mrp = Number(item.mrp || 0);
                  const discount = Number(item.discount || 0);
                  const taxRate = Number(item.taxRate || 0);
                  const sgst = Number(item.sgst || 0);
                  const cgst = Number(item.cgst || 0);
                  const igst = Number(item.igst || 0);
                  const taxable = rate * quantity;
                  const discountAmount = (taxable * discount) / 100;
                  const finalTaxable = taxable - discountAmount;
                  const totalAmount = finalTaxable + cgst + sgst + igst;
                  return (
                    <tr key={idx}>
                      <td>{idx + 1}</td>
                      <td>{item.productName}</td>
                      <td>{item.hsnCode}</td>
                      <td>{customer.state?.substring(0, 3)}</td>
                      <td className="text-right">{quantity.toFixed(2)}</td>
                      <td className="text-right">₹{rate.toFixed(2)}</td>
                      <td className="text-right">₹{mrp.toFixed(2)}</td>
                      <td className="text-right">{discount.toFixed(1)}</td>
                      <td className="text-right">₹{rate.toFixed(2)}</td>
                      <td className="text-right">{taxRate}</td>
                      <td className="text-right">₹{sgst.toFixed(2)}</td>
                      <td className="text-right">₹{cgst.toFixed(2)}</td>
                      <td className="text-right">₹{igst.toFixed(2)}</td>
                      <td className="text-right"><strong>₹{totalAmount.toFixed(2)}</strong></td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          {/* Totals */}
          <div className="invoice-totals-section">
            <div className="totals-summary">
              <div className="summary-row">
                <span>Subtotal:</span>
                <strong>₹{Number(invoice.subtotal || 0).toFixed(2)}</strong>
              </div>
              <div className="summary-row">
                <span>Total Tax:</span>
                <strong>₹{Number(invoice.totalTax || 0).toFixed(2)}</strong>
              </div>
              {invoice.roundOff !== 0 && (
                <div className="summary-row">
                  <span>Round-off:</span>
                  <strong>₹{Number(invoice.roundOff || 0).toFixed(2)}</strong>
                </div>
              )}
              <div className="summary-row grand-total">
                <span>GRAND TOTAL:</span>
                <strong>₹{Number(invoice.grandTotal || 0).toFixed(2)}</strong>
              </div>
            </div>
          </div>

          {/* Status */}
          <div className="invoice-status">
            <p>Status: <span className={`badge badge-${invoice.status}`}>{invoice.status}</span></p>
          </div>
        </div>

        <div className="modal-footer">
          <button 
            type="button" 
            className="btn btn-primary"
            onClick={onPrint}
            title="Print Invoice"
          >
            <Printer size={16} />
            Print
          </button>
          <button 
            type="button" 
            className="btn btn-primary"
            onClick={onDownloadPDF}
            title="Download PDF"
          >
            <Download size={16} />
            Download PDF
          </button>
          <button type="button" className="btn btn-secondary" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
}

export default InvoiceViewModal;
